import { GetStaticPropsContext, InferGetStaticPropsType, NextPage } from 'next';

import { Duration } from 'constants/duration.constants';
import { seoTitleSuffixQuery } from 'queries/global/queries';
import Prefetcher from 'services/prefetcher';

import AccountContainer from 'components/@account/AccountContainer';
import AppNavigation from 'components/@navigation/AppNavigation';
import BasicSeo from 'components/@seo/BasicSeo';

const Account: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  seoTitleSuffix,
}) => {
  return (
    <AppNavigation hideFooterOnMobile>
      <BasicSeo
        titleSuffix={seoTitleSuffix}
        titleIntlId="seo.account.details.title"
      />
      <AccountContainer />
    </AppNavigation>
  );
};

export default Account;

export const getStaticProps = async ({
  locale,
  preview,
}: GetStaticPropsContext) => {
  const prefetcher = await Prefetcher.init({ locale, preview });
  const { seoTitleSuffix } = await prefetcher.prefetch(seoTitleSuffixQuery);

  return {
    props: {
      seoTitleSuffix,
      dehydratedState: prefetcher.dehydratedState,
    },
    revalidate: Duration.TEN_MIN,
  };
};
